import type { FinancialFormValues } from "./financialFormSchema";
import type {
  FinancialStatementCategoryItem,
  FinancialStatementDebtItem,
} from "../domain/entities/financial";

/** Convert an array of view items into the record shape used by the form */
function toRecord(
  arr: (FinancialStatementCategoryItem | FinancialStatementDebtItem)[],
) {
  return Object.fromEntries(
    arr.map((i) =>
      "balance" in i
        ? [
            i.key,
            {
              value: i.value,
              balance: i.balance,
              frequency: i.frequency,
            },
          ]
        : [
            i.key,
            {
              value: i.value,
              frequency: i.frequency,
            },
          ],
    ),
  );
}

export function viewToForm(view: {
  income: FinancialStatementCategoryItem[];
  fixed: FinancialStatementCategoryItem[];
  flexible: FinancialStatementCategoryItem[];
  debts: FinancialStatementDebtItem[] | [];
  monthlySavingsAmount: number;
  fixedOther: any;
  aboutYou?: any;
}): FinancialFormValues {
  return {
    income: toRecord(view.income),
    fixed: toRecord(view.fixed),
    flexible: toRecord(view.flexible),
    debts: toRecord(view.debts),
    monthlySavingsAmount: view.monthlySavingsAmount ?? 0,
    fixedOther:
      (view.fixedOther ?? []).map((x) => ({
        label: x.label ?? "",
        amount: Number(x.amount ?? 0),
        frequency: x.frequency ?? "M",
      })) ?? [],
    aboutYou: view.aboutYou,
  };
}

/** Convert a form record (income/fixed/flexible/debts) into a section array */
export function recordToSectionArray(
  rec: Record<string, any>,
  parent: string,
  categoryByKey: (k: string) => string,
  titleByKey: (k: string) => string,
) {
  return Object.entries(rec).map(([key, v]) => ({
    parent,
    category: categoryByKey(key),
    title: titleByKey(key),
    value: v.value,
    frequency: v.frequency,
    key,
    ...(v as object),
  }));
}
